/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * List of the conditions defining monitor scope of the notification rule
 */
export type PublicFilterNotificationRuleMonitorScopeConditionDto = {
    /**
     * Type of the condition
     */
    type: PublicFilterNotificationRuleMonitorScopeConditionDto.type;
};

export namespace PublicFilterNotificationRuleMonitorScopeConditionDto {

    /**
     * Type of the condition
     */
    export enum type {
        MONITOR_TEMPLATE = 'MONITOR_TEMPLATE',
        TAG = 'TAG',
        SEVERITY = 'SEVERITY',
    }


}
